import { AddOnDto, AddOnDtoTypeEnum } from "../generated/account-client";
import { DEFAULT_ADDON_PRICE } from "../util/constants";

export function getAddonsFriendlyLabel(addons: AddOnDto[]): string {
  const userAddon = addons.find((it) => it.type === AddOnDtoTypeEnum.User);
  const locationAddon = addons.find(
    (it) => it.type === AddOnDtoTypeEnum.Location
  );
  let label = "";

  if (userAddon) {
    const addonQty = userAddon.quantity || 1;
    label += `${addonQty} User Seat${addonQty > 1 ? "s" : ""}`;
  }

  if (locationAddon) {
    const addonQty = locationAddon.quantity || 1;
    if (label) label += ", ";
    label += `${addonQty} Location${addonQty > 1 ? "s" : ""}`;
  }

  return label;
}

export function getAddonsRecurringCharge(addons: AddOnDto[], type: AddOnDtoTypeEnum, deactivatedDevices: number): number {
  let charge = 0;
  addons
    .filter(it => it.type === type)
    .forEach((a) => {
    charge += (a.total || 0) * ((a.quantity || 0) - deactivatedDevices);
  });
  return charge;
}

export function getUserAddonPrice(availableAddons: AddOnDto[]): number {
  return getAddonPrice(availableAddons, AddOnDtoTypeEnum.Location);
}

export function getLocationAddonPrice(availableAddons: AddOnDto[]): number {
  return getAddonPrice(availableAddons, AddOnDtoTypeEnum.Location);
}

export function getAddonPrice(
  availableAddons: AddOnDto[],
  type: AddOnDtoTypeEnum
): number {
  let price = DEFAULT_ADDON_PRICE;
  const addon = availableAddons.find((it) => it.type === type);
  if (addon) {
    price = addon.total || DEFAULT_ADDON_PRICE;
  }
  return price;
}
